// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILeaveContactsV2RequestSchema {
  /** ID черновика **/
  draftId?: number;
  /** Находится ли пользователь за границей **/
  isForeignLocation?: boolean;
  /** Имя контактного лица **/
  name: string;
  /** В каком городе находится объект недвижимости **/
  objectCity?: string;
  /** Номер телефона контактного лица **/
  phone: string;
  /** Этап, на котором остановилось заполнение формы **/
  sentFrom: ESentFrom;
}
export enum ESentFrom {
  /** Получить консультацию (b2b лендинг) **/
  'B2bConsultation' = 'b2bConsultation',
  /** Записаться на мастер класс (b2b лендинг) **/
  'B2bMasterClass' = 'b2bMasterClass',
  /** Выбрать риелтора на ЦИАН (b2с лендинг) **/
  'B2cPickRealtor' = 'b2cPickRealtor',
  /** Ох, провести такие сделки онлайн у нас пока нельзя **/
  'DeclineStep' = 'declineStep',
  /** Есть условия, которые нужно обсудить с персональным помощником **/
  'GrayZone' = 'grayZone',
  /** Пользователь подписался на маркетинговую рассылку при авторизации **/
  'MarketingSubscription' = 'marketingSubscription',
  /** Остались вопросы **/
  'Restrictions' = 'restrictions',
  /** Сервис недоступен **/
  'ServiceNotWorking' = 'serviceNotWorking',
}
